{
  "email-templates": "Plantillas de correo",
  "template-list": "Plantillas de correo",
  "notification-updated": "Notificación Actualizada",
  "title": "Eliminar Notificación",
  "confirmationMessage": "¿Estás seguro de que quieres eliminar esta notificación? Esta acción no se puede deshacer.",
  "title-create": "Crear plantilla de correo",
  "title-edit": "Editar plantilla de correo",
  "subject": "Asunto",
  "notification-deleted": "Notificación eliminada",
  "notification-created": "Notificación creada",
  "text": "Texto",
  "prompt": "Prompt",
  "add-template": "Agregar plantilla",
  "delete-template": "Eliminar plantilla",
  "no-templates": "Aún no hay plantillas",
  "loading": "Cargando plantillas...",
  "load-error": "No pudimos cargar las plantillas.",
  "retry": "Reintentar",
  "compose": "Redactar",
  "preview": "Vista previa"
}
